import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { Icon } from '@mdi/react';

interface ISubCategoryLinkProps {
    active?: boolean;
    first?: boolean;
}

const selectedLink = `
    border-left-color: ${Variables.Colors.b300};
    background-color: ${Variables.Colors.p50};
`;

const firstLink = `
    border-top: 1px solid ${Variables.Colors.platinum};
`;

export const SubCategoryLink = styled.div<ISubCategoryLinkProps>`
    display: flex;
    align-items: center;
    padding-left: 32px;
    padding-right: 16px;
    min-height: 70px;

    border-left: 2px solid transparent;
    border-bottom: 1px solid ${Variables.Colors.platinum};

    ${(props: ISubCategoryLinkProps): string | undefined => (props.active ? selectedLink : undefined)}
    ${(props: ISubCategoryLinkProps): string | undefined => (props.first ? firstLink : undefined)}

    &:hover {
        background-color: ${Variables.Colors.ghostWhite};
        cursor: pointer;
    }
`;
export const Chevron = styled(Icon)`
    fill: ${Variables.Colors.n30};
`;
export const Pair = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: 0; // Required for text-overflow on Value
`;
export const Label = styled.div`
    flex-grow: 1;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n100};
`;
export const Value = styled.div`
    display: block;
    overflow-x: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
    font-size: 18px;
    color: ${Variables.Colors.n30};
    margin-top: 4px;
`;
